import {
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";

import type { UploadedFile } from "../types";

interface FilesListProps {
  files: UploadedFile[];
  onDeleteFile: (file: UploadedFile) => void;
  isSubmitting?: boolean;
}

export function FilesList({
  files,
  onDeleteFile,
  isSubmitting = false,
}: FilesListProps): React.JSX.Element | null {
  if (files.length === 0) return null;

  return (
    <List disablePadding>
      {files.map((f) => (
        <ListItem
          key={f.name}
          disableGutters
          secondaryAction={
            <IconButton
              edge="end"
              size="small"
              onClick={() => onDeleteFile(f)}
              disabled={isSubmitting}
              aria-label={`Remove ${f.name}`}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          }
          sx={{
            py: 1.5,
            overflow: "hidden",
          }}
        >
          <ListItemIcon sx={{ minWidth: 32 }}>
            <UploadFileOutlinedIcon fontSize="small" color="action" />
          </ListItemIcon>
          <Tooltip title={f.name} placement="top-start">
            <ListItemText
              primary={f.name}
              slotProps={{
                primary: {
                  variant: "body2",
                  noWrap: true,
                  sx: {
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    pr: 4,
                  },
                },
              }}
            />
          </Tooltip>
        </ListItem>
      ))}
    </List>
  );
}
